import React from 'react';
import { FileText, ExternalLink } from 'lucide-react';

export function ContactInfo() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <FileText className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Informacje zwrotne i dane kontaktowe
        </h2>
      </div>
      
      <div className="space-y-4">
        <p className="body-medium">
          W przypadku problemów z dostępnością strony internetowej prosimy o kontakt z osobą odpowiedzialną za dostępność:
        </p>
        
        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h3 className="heading-5 mb-4">
            Dane kontaktowe osoby odpowiedzialnej za dostępność
          </h3>
          <div className="space-y-3">
            <div>
              <h4 className="label-large mb-1">
                Podmiot odpowiedzialny
              </h4>
              <p className="body-medium no-margin">
                EPKO sp. z o.o.
              </p>
            </div>
            <div>
              <h4 className="label-large mb-1">
                Email
              </h4>
              <p className="body-medium no-margin">
                <a href="mailto:biuro@epko.tech" className="link-primary">biuro@epko.tech</a>
              </p>
            </div>
            <div>
              <h4 className="label-large mb-1">
                Strona internetowa
              </h4>
              <p className="body-medium no-margin">
                <a href="https://www.epko.tech" target="_blank" rel="noopener noreferrer" className="link-primary">www.epko.tech</a>
              </p>
            </div>
          </div>
        </div>
        
        <p className="body-medium">
          Można także składać wnioski o udostępnienie informacji niedostępnej oraz składać skargi na brak zapewnienia dostępności. W sprawach związanych z fundacją można kontaktować się również z Fundacją Znajdki pod adresem <a href="mailto:znajdki2012@gmail.com" className="link-primary">znajdki2012@gmail.com</a> lub dzwoniąc na numer telefonu <a href="tel:+48664821160" className="link-primary">664 821 160</a>.
        </p>
        <p className="body-medium">
          Każdy ma prawo do wystąpienia z żądaniem zapewnienia dostępności cyfrowej strony internetowej, aplikacji mobilnej lub jakiegoś ich elementu. Można także zażądać udostępnienia informacji w formach alternatywnych, na przykład odczytanie niedostępnego cyfrowo dokumentu, opisania zawartości filmu bez audiodeskrypcji itp. Żądanie powinno zawierać dane osoby zgłaszającej żądanie, wskazanie, o którą stronę internetową chodzi oraz sposób kontaktu. Jeżeli osoba żądająca zgłasza potrzebę otrzymania informacji w formie alternatywnej, powinna także określić formę tej informacji.
        </p>
        <p className="body-medium">
          Podmiot publiczny powinien zrealizować żądanie niezwłocznie i nie później, niż w ciągu 7 dni. Jeżeli dotrzymanie tego terminu nie jest możliwe, podmiot publiczny niezwłocznie informuje o tym, kiedy realizacja żądania będzie możliwa, przy czym termin ten nie może być dłuższy niż 2 miesiące. Jeżeli zapewnienie dostępności nie jest możliwe, podmiot publiczny może zaproponować alternatywny sposób dostępu do informacji.
        </p>
        <p className="body-medium">
          W przypadku, gdy podmiot odmówi realizacji żądania zapewnienia dostępności lub alternatywnego dostępu do informacji, można złożyć skargę na takie działanie.
        </p>
        <p className="body-medium">
          Po wyczerpaniu wszystkich możliwości skargę można przesłać także do <a href="https://www.rpo.gov.pl/" target="_blank" rel="noopener noreferrer" className="link-primary flex items-center gap-1">Rzecznika Praw Obywatelskich <ExternalLink className="w-3 h-3" /></a>.
        </p>
      </div>
    </div>
  );
}